/* eslint-disable import/order */
/* eslint-disable camelcase */
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import {
  Card,
  Button,
  Container,
  Typography,
  Box,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  IconButton
} from '@mui/material';
// routes
import axios, { getErrorMessage } from 'utils/axios';
import useIsMountedRef from 'hooks/useIsMountedRef';
import CRUD from 'utils/Crud';
import { fDate, fDateTime } from 'utils/formatTime';
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
// sections
import { DataGrid } from '@mui/x-data-grid';
import { LoadingButton } from '@mui/lab';
import SearchQueryDailog from 'sections/@dashboard/SearchQueryDailog';
import { useSnackbar } from 'notistack';
import EditUserModal from 'sections/@dashboard/user/EditUserModal';
import CustomGridToolbar from 'components/CustomGridToolbar';
// ----------------------------------------------------------------------



export default function UserList() {
  const { themeStretch } = useSettings();
  const isMountedRef = useIsMountedRef();
  const navigate = useNavigate();
  const [modal, setModal] = useState({open:false, user:{}});
  const [sort, setSort] = useState({field:'id', order:'asc'});
  const [data, setData] = useState({data:[],current_page:1,total_pages:null,total_size:0,page_size:0});
  const [state,setState] = useState({loading:false,loadComplete:false,error:null});
  const [query,setQuery] = useState({page_size:100,page:0});
  const [dailog,setDailog] = useState({open:false,query:"",});
  const [search,setSearch] = useState({open:false,query:"", list:[]});
  const { enqueueSnackbar } = useSnackbar();


  useEffect(() => {
    getInitData();
  }, []);

  // const updateData = (k, v) => setData((prev) => ({ ...prev, [k]: v }));

  return (
    <Page title="Users list">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="All users"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'User', href: PATH_DASHBOARD.user.root },
            { name: 'List' },
          ]}
          action={
            <Button
              variant="contained"
              component={Button}
              onClick={()=>{
                setDailog({open:true, isEdit: false});
              }}
              startIcon={<Iconify icon={'cil:search'} />}
            >
             Find user
            </Button>
          }
        />

        {!state.loading && state.error !=null && (
          <Card>
            <Box padding={10} display={"flex"} justifyContent={"center"}>
            <p>Error {state.error} </p>
            </Box>
          </Card>
        )}

        <Card>
          {search.open && 
          <Box sx={{display:"flex", alignContent:"right", justifyContent:"space-between", width:"100%", padding:2}}>
            <p>Showing results for: {search.query}</p>
            <LoadingButton sx={{mr:2}}
              startIcon={<Iconify icon={'carbon:close-filled'} />}
              loading={state.loading} 
              onClick={()=> setSearch({...search, open:false})}
               variant='outlined' color="error">
                Close search
            </LoadingButton>
          </Box>}
          {!search.open && 
          <Box sx={{display:"flex", alignContent:"right", justifyContent:"end", width:"100%", padding:2}}>
            <FormControl sx={{width:180}}>
              <InputLabel id="demo-simple-select-label">Sort field</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                label="Sort field"
                value={sort.field}
                onChange={(e)=> setSort({...sort,field:e.target.value})}
                >
                {[
                  {v:'id',n:"Default"},
                  {v:'first_name',n:"First name"},
                  {v:'last_name',n:"Last name"},
                  {v:'created_at',n:"Join date"},
                  {v:'last_seen_at',n:"Last seen"},
                  ].map((opt,i) => (
                <MenuItem key={i} value={opt.v}>{opt.n}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ml:2,width:180}}>
              <InputLabel id="demo-simple-select-label2">Sort order</InputLabel>
              <Select
                labelId="demo-simple-select-label2"
                label="Sort order"
                value={sort.order}
                onChange={(e)=> setSort({...sort,order:e.target.value})}
              >
                {[
                  {v:'asc',n:"Ascending"},
                  {v:'desc',n:"Descending"},
                  ].map((opt,i) => (
                <MenuItem key={i} value={opt.v}>{opt.n}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <LoadingButton loading={state.loading} onClick={()=> getInitData()}
              sx={{ml:2}} variant='outlined' color="secondary">
                Apply changes
            </LoadingButton> 
            
          </Box>}

          <Box sx={{ height: 850, width: '100%' }}>
            <DataGrid
              rows={search.open ? search.list : data.data}
              columns={[
                {
                  field: 'display_name',
                  headerName: 'Name',
                  width: 220,
                  editable: false,
                  renderCell: (params) => (
                    < >
                      <IconButton
                        color="primary"
                        onClick={() =>
                          navigate(PATH_DASHBOARD.users.details(params.row.user_id), {
                            state: { user: params.row },
                          })
                        }
                      >
                        <Iconify icon={'ph:user-thin'} size="small" sx={{width:25,height:25}} />
                      </IconButton>
                      <Typography
                        variant="subtitle2"
                        sx={{cursor:"pointer"}}
                        noWrap
                        onClick={() =>
                          navigate(PATH_DASHBOARD.users.details(params.row.user_id), {
                            state: { user: params.row },
                          })
                        }
                      >
                        {params.value}
                      </Typography>
                    </>
                  ),
                  valueGetter: (params) => params.value
                },
                {
                  field: 'email',
                  headerName: 'Email',
                  width: 180,
                  editable: false,
                },
                {
                  field: 'phone',
                  headerName: 'Phone',
                  width: 180,
                  editable: false,
                },
                {
                  field: 'gender',
                  headerName: 'Gender',
                  width: 180,
                  editable: false,
                },
                {
                  field: 'referral_id',
                  headerName: 'Promo code',
                  width: 180,
                  editable: false,
                },
                // {
                //   field: 'account_verification_status',
                //   headerName: 'KYC Status',
                //   width: 120,
                //   editable: false,
                //   renderCell: (params) => {
                //     let color = 'error';
                //     if(params.value === "pending"){
                //       color = 'warning';
                //     }
                //     if(params.value === "complete"){
                //       color = 'success';
                //     }
                //     return  <Label
                //               variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                //               color={color} >
                //           {sentenceCase(params.value || "unverified")}
                //         </Label>
                //   },
                //   valueGetter: (params) => params.value
                // },
                {
                  field: 'last_seen_at',
                  headerName: 'Last seen',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => fDateTime(params.value),
                  // valueGetter: (params) => params.row.updated_at
                },
                {
                  field: 'created_at',
                  headerName: 'Joined at',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => fDate(params.value),
                  // valueGetter: (params) => params.row.updated_at
                },
                {
                  field: "actions",
                  type: "actions",
                  align: "right",
                  width: 280,
                  headerName: "Actions",
                  getActions: (params) => [
                    <Button 
                      key={2}
                      variant='outlined'
                      color="secondary"
                      onClick={()=> {
                        setModal({open:true, isEdit:true, user:params.row});
                      }}
                      startIcon={<Iconify icon={'eva:edit-fill'} /> }
                      >
                        Update
                    </Button>,
                    <Button 
                      key={3}
                      variant='outlined'
                      color="error"
                      onClick={() => alert(params.row)}
                      startIcon={<Iconify icon={'eva:trash-2-outline'} />}
                      >
                        Delete
                  </Button>
                  ],
                },
              
              ]}
              
              // rowsPerPageOptions={[50,100,250,500]}
              loading={state.loading}
              checkboxSelection
              disableRowSelectionOnClick
              components={{ Toolbar: CustomGridToolbar }}
             
              disableSelectionOnClick

              // pagination={false}
              paginationMode="server"
              rowCount={data.total_size}
              page={data.current_page - 1}
              rowsPerPage={data.data.length}
              onPageChange={(newPage)=> {
                setQuery({...query, page:newPage + 1});
                getInitData(newPage + 1);
              }}
              pageSize={data.page_size}
              onPageSizeChange={(newPage) => setQuery({...query, page_size:newPage})}
              rowsPerPageOptions={[]}
              
            />
          </Box>
        </Card>
      </Container>


     {modal.open &&  <EditUserModal
        open={modal.open}
        user={modal.user}
        handleClose={()=>{
          setModal({open:false});
        }}
        handleComplete={()=>{
          setModal({open:false});
          getInitData();
        }}
         />}
      {dailog.open &&  <SearchQueryDailog
        open={dailog.open}
        hint='Search user database for matching records'
        label="Enter user I.D, name, email or phone number"
        handleClose={()=>{
          setDailog({open:false});
        }}
        onSubmit={(val)=>{
          setDailog({open:false});
          searchUser(val);
        }}
        />}

    </Page>
  );

  async function getInitData(page = null) {
    
    if(data.data.length > 0){
      setData({...data,data:[]});
    }
    setState({...state,loading:true,loadComplete:false,error:null});

    try {
      let str = `?sort_field=${sort.field}&sort_order=${sort.order}`;
        str+= `&page=${page || query.page}&&page_size=${query.page_size}`;

      const response = await axios.get(CRUD.user.list+str);

      // if (isMountedRef.current) {
      //   setData(response.data);
      // }
      const ret = response.data;
      // console.log(ret)
      const dataWithId = ret.data.map((item, index) => ({
        ...item,
        id: item.id ?? index, // use existing id if present, else fallback to index
      }));
      setData({...response.data,data:dataWithId});
      setState({...state,loading:false,loadComplete:true,error:null})
    } catch (error) {
      // console.error(error);
      setState({...state,loading:false,loadComplete:false,error: getErrorMessage(error)})
    }
  };


  async function searchUser(query) {
    
    setState({...state,loading:true});
    setSearch({open:true,query,list:[]});

    try {
      const str = `?query=${query}`;
      const response = await axios.get(CRUD.user.search+str);
      // console.log("lsit",response.data)

      if (isMountedRef.current) {
        const dataWithId = response.data.map((item, index) => ({
          ...item,
          id: item.id ?? index, // use existing id if present, else fallback to index
        }));
        setSearch({open:true,query, list:dataWithId});
        setState({...state,loading:false});
      }
    } catch (error) {
      // console.error(error);
      setState({...state,loading:false});
      enqueueSnackbar(getErrorMessage(error),{variant:'error'});
    }
  };

}
